import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import ItemMasterModal from "../components/itemMasterModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const AddNewItem = () => {
  useAuthRedirect();
  const {codee} = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(null);  
  const [itemName, setItemName] = useState(null);  
  const [part, setPart] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [uom, setUom] = useState([])
const [formData, setFormData] = useState({
    itemCode: "", itemName: "", user: "", partNo: "", uom: "", price: "", type: "", openingStock: "",
    location: "", opnNo: "", closingStock: "", lead: "", pUom: "", conversion: "", class: "", min: "", max: "",
    rg: "", serial: "",serialNumbers: []
})
const navigate = useNavigate();

/////////////////////////////////////////////////////////////
    const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
      const permsLoaded = !!rawPerms;
      
      //✅ Permission checks (safe even if perms not yet loaded; will be false)
      const canEntry = hasPermission("Item", "entry");
      /////////////////////////////////////////////////////////////
    

useEffect(() => {
    const fetchUom = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_addUom`);
        setUom(response.data.fetchUomList || []);
        console.log(response.data.fetchUomList);
        
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchUom();
  }, []);


const handleSelectItem = async (supplier) => {
  try {
    setItemName(supplier.itemName); 
    setCode(supplier.code)
    setPart(supplier.partNo)
  } catch (error) {
    console.error("Error fetching supplier items:", error);
  }
};


const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "openingStock") {
      const num = parseInt(value, 10);
      setFormData((prev) => ({
        ...prev,
        openingStock: value,
        serialNumbers: isNaN(num) || num <= 0 ? [] : new Array(num).fill(""),
      }));
    } else if (name.startsWith("serialNo_")) {
      const index = parseInt(name.split("_")[1], 10);
      setFormData((prev) => {
        const updatedSerialNumbers = [...prev.serialNumbers];
        updatedSerialNumbers[index] = value;
        return { ...prev, serialNumbers: updatedSerialNumbers };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!(code || '').trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Itemcode!',
      });
      return;
    }
    
     if (!(formData.uom || '').trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Unit of Measurement!',
      });
      return;
    }

    if (!(formData.pUom || '').trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Purchase UOM!',
      });
      return;
    }

      // Check Conversion
if (!(formData.Conversion || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter Conversion!',
  });
  return;
}
if (isNaN(formData.Conversion)) {
  Swal.fire({
    icon: 'error',
    title: 'Invalid Input',
    text: 'Conversion must be a number!',
  });
  return;
}

// Check Lead
if (!(formData.lead || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter Lead time!',
  });
  return;
}
if (isNaN(formData.lead)) {
  Swal.fire({
    icon: 'error',
    title: 'Invalid Input',
    text: 'Lead time must be a number!',
  });
  return;
}

// Check Price
if (!(formData.price || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter Price!',
  });
  return;
}
if (isNaN(formData.price)) {
  Swal.fire({
    icon: 'error',
    title: 'Invalid Input',
    text: 'Price must be a number!',
  });
  return;
}


// Check Type
if (!(formData.opnNo || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter OPN No!',
  });
  return;
}
if (isNaN(formData.opnNo)) {
  Swal.fire({
    icon: 'error',
    title: 'Invalid Input',
    text: 'OPN No must be a number!',
  });
  return;
}

// Check Type
if (!(formData.location || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter Your Location!',
  });
  return;
}

// Normalize and validate inputs as numbers
const minStr = (formData.min ?? "").toString().trim();
if (!minStr) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Please Enter Minimum Stock!",
  });
  return;
}
const minVal = Number(minStr);
if (!Number.isFinite(minVal)) {
  Swal.fire({
    icon: "error",
    title: "Invalid Input",
    text: "Minimum Stock must be a number!",
  });
  return;
}

const maxStr = (formData.max ?? "").toString().trim();
if (!maxStr) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Please Enter Maximum Stock!",
  });
  return;
}
const maxVal = Number(maxStr);
if (!Number.isFinite(maxVal)) {
  Swal.fire({
    icon: "error",
    title: "Invalid Input",
    text: "Maximum Stock must be a number!",
  });
  return;
}

// Numeric comparison (now correct)
if (minVal > maxVal) {
  Swal.fire({
    icon: "warning",
    title: "Validation Error",
    text: "Minimum Stock cannot be greater than Maximum Stock.",
  });
  return;
}


if (!(formData.class || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Select Your Class!',
  });
  return;
}

if (!(formData.rg || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Select RG Type!',
  });
  return;
}

  
if (!(formData.serial || '').trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Select Serial!',
  });
  return;
}   

  const payload = {
    branch: branch,
    itemCode: code,
    itemName: itemName,
    user: user,
    partNo: formData.partNo,
    itemUom: formData.uom,
    price: formData.price,
    type: code,
    openingStock: formData.openingStock,
    location: formData.location,
    opnNo: formData.opnNo,
    closingStock: formData.closingStock,
    lead: formData.lead,
    pUom: formData.pUom,
    conversion: formData.Conversion,
    classType: formData.class,
    min: formData.min,
    max: formData.max,
    rg: formData.rg,
    items: formData.serialNumbers.map((serial) => ({
      serial: serial,
    })),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post("https://rfs2.infraconsoft.net.in/api/itemMaster_insert", payload);

    Swal.fire("Success", "Item added successfully", "success");
    navigate('/inventory/itemmasterviewnew');

  } catch (error) {
    console.error("Error submitting form:", error);

    const errorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "Submission failed. Please try again.";

    Swal.fire("Error", errorMessage, "error");
  }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Item Master - Add</h2>
                    <Link to='/inventory/itemmasterviewnew'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>Item Code :</label>
                <input type="text" name="code" value={code} onClick={() => setShowModal(true)} readOnly placeholder="Select Item Code"/>
              </div>
              <div className="form-group">
                <label>Item Name :</label>
                <input type="text" name="itemName" value={itemName} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch Code :</label>
                <input type="text" name="branchCode" value={branch} readOnly/>
              </div>
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branchName" value={branch} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>UOM :</label>
                <select name="uom" value={formData.uom} onChange={handleChange}>
                    <option value="">-- Select UOM --</option>
                    {(uom.map((item, index) => (
                    <option key={index} value={item.uommaster_shortname}>
                        {item.uommaster_shortname}
                    </option>
                    )))}
                </select>
              </div>
              <div className="form-group">
                <label>Purchase UOM :</label>
                <select name="pUom" value={formData.pUom} onChange={handleChange}>
                    <option value="">-- Select UOM --</option>
                    {(uom.map((item, index) => (
                    <option key={index} value={item.uommaster_shortname}>
                        {item.uommaster_shortname}
                    </option>
                    )))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Conversion :</label>
                <input type="text" name="Conversion" value={formData.Conversion}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Lead Time :</label>
                <input type="text" name="lead" value={formData.lead}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Price :</label>
                <input type="text" name="price" value={formData.price} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="type" value={(code || "").substring(0, 3)} onChange={handleChange} />


              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tariff Heading/ OPN No :</label>
                <input type="text" name="opnNo" value={formData.opnNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Location :</label>
                <input type="text" name="location" value={formData.location} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Stock (Minimum) :</label>
                <input type="text" name="min" value={formData.min}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Stock (Maximum) :</label>
                <input type="text" name="max" value={formData.max} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Class :</label>
                <select name="class" value={formData.class} onChange={handleChange}>
                  <option value="">-- Select Class --</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                </select>
              </div>
              <div className="form-group">
                <label>RG23 Type :</label>
                <select name="rg" value={formData.rg} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="RG-23A">RG-23A</option>
                  <option value="RG-23C">RG-23C</option>
                  <option value="Others">Others</option>
                </select>
              </div>
            </div>

            <div className="form-row">
        <div className="form-group">
          <label>Serial No :</label>
          <select name="serial" value={formData.serial} onChange={handleChange}>
            <option value="">-- Select --</option>
            <option value="YES">Yes</option>
            <option value="NO">No</option>
          </select>
        </div>
        <div className="form-group">
          <label>Part No :</label>
          <input type="text" name="partNo" value={formData.partNo} onChange={handleChange} />
        </div>
      </div>

      {formData.serial === "YES" && (
        <div className="form-row">
          <div className="form-group">
            <label>Opening Stock :</label>
            <input
              type="number"
              name="openingStock"
              value={formData.openingStock}
              onChange={handleChange}
            />
          </div>
        </div>
      )}

{formData.serial === "NO" && (
        <div className="form-row">
          <div className="form-group">
            <label>Opening Stock :</label>
            <input
              type="text"
              name="closingStock"
              value={formData.closingStock}
              onChange={handleChange}
            />
          </div>
        </div>
      )}

      {formData.serial === "YES" &&
        formData.serialNumbers.map((val, index) => (
          <div className="form-group" key={index}>
            <label>Serial No {index + 1} :</label>
            <input
              type="text"
              name={`serialNo_${index}`}
              value={val}
              onChange={handleChange}
            />
          </div>
        ))}







            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <ItemMasterModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddNewItem;
